import React, { useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import "./Dashboard.scss";
import { Box, Link } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import RiskScore from "../../../../Components/Desktop/Employee/RiskScore/RiskScore";
import TwoWheelerPopup from "./TwoWheelerPopup/TwoWheelerPopup";
import FourWheelerPopup from "./FourWheelerPopup/FourWheelerPopup";
import TravelPopup from "./TravelPopup/TravelPopup";
import TermPopup from "./TermPopup/TermPopup";
import InvestmentPopup from "./InvestmentPopup/InvestmentPopup";
import HealthPopup from "./HealthPopup/HealthPopup";


const Dashboard = () => {
  const [showHealthPolicy, setShowHealthPolicy] = useState(true);
  const [showNoHealthPolicy, setShowNoHealthPolicy] = useState(false);
  const [showTermPolicy, setShowTermPolicy] = useState(true);
  const [showNoTermPolicy, setShowNoTermPolicy] = useState(false);
  const [showRiskScore, setShowRiskScore] = useState(true);
  const [showNoRiskScore, setShowNoRiskScore] = useState(false);
  const [twoWheeler, setTwoWheeler] = React.useState<boolean>(false);
  const [fourWheeler, setFourWheeler] = React.useState<boolean>(false);
  const [travel, setTravel] = React.useState<boolean>(false);
  const [term, setTerm] = React.useState<boolean>(false);
  const [investment, setInvestment] = React.useState<boolean>(false);
  const [health, setHealth] = React.useState<boolean>(false);

  const toggleHealthDivs = () => {
    setShowHealthPolicy(!showHealthPolicy);
    setShowNoHealthPolicy(!showNoHealthPolicy);
  };
  const toggleTermDivs = () => {
    setShowTermPolicy(!showTermPolicy);
    setShowNoTermPolicy(!showNoTermPolicy);
  };
  const toggleRiskDivs = () => {
    setShowRiskScore(!showRiskScore);
    setShowNoRiskScore(!showNoRiskScore);
  };

  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };
  const [quote, setQuote] = useState([
    {
      quote:
        "Hope is the thing with feathers that perches in the soul and sings the tune without the words and never stops at all. ",
      author: "Emily Dickinson",
    },
    {
      quote:
        "Success is not the key to happiness. Happiness is the key to success. If you love what you are doing, you will be successful.",
      author: "Albert Schweitzer",
    },
    {
      quote:
        "The future belongs to those who believe in the beauty of their dreams.",
      author: "Eleanor Roosevelt",
    },
    {
      quote: "The only way to do great work is to love what you do.",
      author: "Steve Jobs",
    },
  ]);
  const selectedQuote = Math.floor(Math.random() * quote.length);

  return (
    <>
      <HealthPopup
        open_status={health}
        attrName={setHealth}
        value_update={updateMasterState}
      />
      <TwoWheelerPopup
        open_status={twoWheeler}
        attrName={setTwoWheeler}
        value_update={updateMasterState}
      />
      <FourWheelerPopup
        open_status={fourWheeler}
        attrName={setFourWheeler}
        value_update={updateMasterState}
      />
      <TravelPopup
        open_status={travel}
        attrName={setTravel}
        value_update={updateMasterState}
      />
      <TermPopup
        open_status={term}
        attrName={setTerm}
        value_update={updateMasterState}
      />
      <InvestmentPopup
        open_status={investment}
        attrName={setInvestment}
        value_update={updateMasterState}
      />

      <Grid xs className="dashbaordWrapper">
        <Grid container spacing={3}>
          <Grid xs={8}>
            <Box className="pageTitle mb-6">
              <h2>
                <span>Hi, Rahul</span> - Discover for yourself
              </h2>
              <p>
                High-level information in one view that makes the related
                information easier to understand.
              </p>
            </Box>
            <Grid container spacing={0} className="insurancePolicies">
              {/* Health Policy */}
              {showHealthPolicy && (
                <Grid
                  xs
                  className="healthPolicy"
                  onClick={toggleHealthDivs}
                  style={{ cursor: "pointer" }}
                >
                  <img src="./images/healthPolicyImg.svg" />
                  <div className="policyDetail">
                    <p>Health Insurance</p>
                    <h4>₹ 5 Lakh</h4>
                    <p className="covered">2 Adults & 1 Child</p>
                  </div>
                </Grid>
              )}
              {showNoHealthPolicy && (
                <Grid
                  xs
                  className="healthPolicy"
                  onClick={toggleHealthDivs}
                  style={{ cursor: "pointer" }}
                >
                  <img src="./images/healthPolicyNone.svg" />
                  <div className="policyDetail">
                    <p className="highlight mb-1">You're Missing</p>
                    <p>Health Insurance</p>
                    <p className="smText mt-1">
                      It covers medical expenses for illness or injuries.
                    </p>
                  </div>
                </Grid>
              )}

              <Grid xs>
                {/* Term Policy */}
                {showTermPolicy && (
                  <div
                    className="termInsurance"
                    onClick={toggleTermDivs}
                    style={{ cursor: "pointer" }}
                  >
                    <img src="./images/yesTermPolicy.svg" />
                    <div>
                      <p>
                        <span>Term</span> Insurance
                      </p>
                      <h4 className="mt-2 mb-0">₹ 5 Lakh</h4>
                    </div>
                  </div>
                )}
                {showNoTermPolicy && (
                  <div
                    className="termInsurance"
                    onClick={toggleTermDivs}
                    style={{ cursor: "pointer" }}
                  >
                    <img src="./images/noTermPolicy.svg" />
                    <div>
                      <p className="highLight mb-1">You're Missing</p>
                      <p>
                        <span>Term</span> Insurance
                      </p>
                      <p className="smText mt-2">
                        It offers your family a sum of money in <br />
                        case of an unfortunate incident.
                      </p>
                    </div>
                  </div>
                )}

                {/* Risk Score */}
                {showRiskScore && (
                  <div
                    className="riskCover"
                    onClick={toggleRiskDivs}
                    style={{ cursor: "pointer" }}
                  >
                    <div>
                      <RiskScore
                        class_name="svg-pi-wrapper riskmap"
                        progress_one={50}
                      ></RiskScore>
                    </div>
                    <div className="percentage">
                      56<span>%</span>
                    </div>
                    <div>
                      <h4>Risk Cover</h4>
                      <p>Know your ideal insurance requirement</p>
                    </div>
                  </div>
                )}
                {showNoRiskScore && (
                  <div
                    className="riskCover"
                    onClick={toggleRiskDivs}
                    style={{ cursor: "pointer" }}
                  >
                    <img src="./images/riskMap.svg" className="mr-4" />
                    <div>
                      <h4>Risk Cover</h4>
                      <p>
                        To know your ideal insurance requirement you need to ask
                        to unlock this feature.
                      </p>
                    </div>
                  </div>
                )}
              </Grid>
            </Grid>
            <Grid container>
              <Grid xs={12} className="otherPlans">
                <Box className="supertopup">
                  <h4>₹ 90 Lakh</h4>
                  <p>
                    <span>Super</span> Topup
                  </p>
                </Box>
                <Box className="ci">
                  <h4>₹ 10 Lakh</h4>
                  <p>
                    <span>Critical</span> illness
                  </p>
                </Box>
                <Box className="pa">
                  <h4>₹ 5 Lakh</h4>
                  <p>
                    <span>Personal</span> Accident
                  </p>
                </Box>
                <Box className="travel">
                  <h4>$ 50,000</h4>
                  <p>
                    <span>Travel</span> Insurance
                  </p>
                </Box>
              </Grid>
            </Grid>
            <Box className="thoughtofTheDay">
              <div className="icon">
                <img src="./images/thought-icon.svg" /> Thought of the day
              </div>
              <div className="thoughtText">
                <span>"</span> {quote[selectedQuote]?.quote} <span>"</span>{" "}
                <div className="author">- {quote[selectedQuote]?.author}</div>
              </div>
            </Box>
            <Grid container spacing={1} className="buyInsurance">
              <Grid xs={8} className="subHeading">
                <h3>
                  <span>Buy</span> Insurance
                </h3>
                <p>
                  Retail insurance policies to cover you from different types of
                  risks.
                </p>
              </Grid>
              <Grid xs={4} textAlign={"right"}>
                <Link className="viewPolicy">
                  View Policies{" "}
                  <RemoveRedEyeOutlinedIcon className="outlineIcon" />
                  <VisibilityIcon className="solidIcon" />
                </Link>
              </Grid>
              <Grid xs={12}>
                <ul className="productList">
                  <li
                    className="healthInsurance"
                    onClick={() => setHealth(true)}
                  >
                    <span>Health</span> Insurance
                  </li>
                  <li
                    className="carInsurance"
                    onClick={() => setFourWheeler(true)}
                  >
                    <span>Car</span> Insurance
                  </li>
                  <li
                    className="bikeInsurance"
                    onClick={() => setTwoWheeler(true)}
                  >
                    <span>Bike</span> Insurance
                  </li>
                  <li className="termInsurance" onClick={() => setTerm(true)}>
                    <span>Term</span> Insurance
                  </li>
                  <li
                    className="investmentPlan"
                    onClick={() => setInvestment(true)}
                  >
                    <span>Investment</span> Plan
                  </li>
                  <li
                    className="travelInsurance"
                    onClick={() => setTravel(true)}
                  >
                    <span>Travel</span> Insurance
                  </li>
                </ul>
              </Grid>
            </Grid>
          </Grid>
          <Grid xs={4}>
            <div className="toDoList">
              <h4>
                📌 <span>To</span> Do
              </h4>
              <ul>
                <li>
                  <img src="./images/toDo-Icon.svg" className="my-2" />
                  <p>You should complete the following steps.</p>
                </li>
                <li>
                  <Link className="addpolicy">
                    <p>Add Policy</p>
                  </Link>
                </li>
                <li>
                  <Link className="addMember">
                    <p>Add Member</p>
                  </Link>
                </li>
                <li>
                  <Link className="riskScore">
                    <p>Risk Score</p>
                  </Link>
                </li>
              </ul>
            </div>
            {/* Requests */}
            <div className="yourRequests">
              <h3>
                🔖 <span>Your</span> Request
              </h3>
              <ul>
                <li>
                  <Link className="addNewRequest">
                    <span>
                      <PlaylistAddIcon />
                    </span>
                    <p>
                      New <br />
                      Request
                    </p>
                  </Link>
                </li>
                <li>
                  <Link className="endorsement">
                    <div className="icon">
                      <HourglassBottomIcon sx={{ color: "#FBA31D" }} />
                    </div>
                    <span>Endorsement</span>
                    <p>Health Insurance</p>
                  </Link>
                </li>
                <li>
                  <Link className="claim">
                    <div className="icon">
                      <CheckCircleOutlineIcon sx={{ color: "#2ddd2d" }} />
                    </div>
                    <span>Cashless Claim</span>
                    <p>Health Insurance</p>
                  </Link>
                </li>
              </ul>
            </div>
            {/* Advertisement */}
            <Box
              className="advertisementBox pl-3 py-4"
              style={{
                backgroundImage: `url('./images/investment_advetisement.svg')`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "200px",
                backgroundPosition: "top right",
              }}
            >
              <h3>
                <span>Low Risk</span>
                <br /> Investment Plans
              </h3>
              <p>
                Achive your financial goals with
                <br /> huge returns
              </p>
              <Link sx={{ background: "#FBA31D" }}>Get Free Quotes</Link>
            </Box>
            <Box
              className="advertisementBox pr-3 py-4"
              style={{
                backgroundColor: "#F0F7FE",
                backgroundImage: `url('./images/repair_vehicle.svg')`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "250px",
                backgroundPosition: "bottom left",
                textAlign: "right",
              }}
            >
              <h3>
                <span>Repair</span> Vehicle
              </h3>
              <p>
                It is now easy to search for <br />
                car repair & services online
              </p>
              <Link sx={{ background: "#D8433D" }}>Read More</Link>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default Dashboard;
